import { Label, RefNumber } from "@tblabs/truffle";
import { DatesRange } from "../../../Models/Dates/DatesRange";
import { DateInputWithIcon } from "./DateInputWithIcon";
import { Table } from "@tblabs/truffle/Controls/TableBuilder/Table";
import { SimpleQuantityBox } from "./QuantityBox";


export class DatesRangeAndQuantityBox extends Table
{
    constructor(datesRange: DatesRange, quantity: RefNumber)
    {
        super([],
            [
                [
                    new Label("Od").Class("product__form-label"),
                    new DateInputWithIcon(datesRange.Start, "start-date-input"),
                ],
                [
                    new Label("Do").Class("product__form-label"),
                    new DateInputWithIcon(datesRange.End, "end-date-input"),
                ],
                [
                    new Label("Ilość").Class("product__form-label"),
                    new SimpleQuantityBox(quantity, "quantity-input"),
                ]
            ]);
    }
}
